import { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [assets, setAssets] = useState(() => {
    const saved = localStorage.getItem("assets");
    return saved ? JSON.parse(saved) : [];
  });

  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");

  useEffect(() => {
    localStorage.setItem("assets", JSON.stringify(assets));
  }, [assets]);

  const addAsset = () => {
    const trimmedName = name.trim();

    if (!trimmedName || Number(amount) <= 0) {
      alert("Введите корректные данные");
      return;
    }

    const newAsset = {
      id: Date.now(),
      name: trimmedName,
      amount: Number(amount),
    };

    setAssets([...assets, newAsset]);
    setName("");
    setAmount("");
  };

  const deleteAsset = (id) => {
    setAssets(assets.filter((asset) => asset.id !== id));
  };

  const total = assets.reduce((sum, asset) => sum + asset.amount, 0);

  return (
    <div className="container">
      <h1>Simple Investment Tracker</h1>

      <div className="form">
        <input
          type="text"
          placeholder="Asset name (e.g. Apple)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && addAsset()}
        />

        <input
          type="number"
          placeholder="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && addAsset()}
        />

        <button onClick={addAsset}>Add</button>
      </div>

      <h2>Total: ${total}</h2>

      {assets.length === 0 ? (
        <p>No assets yet</p>
      ) : (
        <ul>
          {assets.map((asset) => (
            <li key={asset.id}>
              {asset.name} — ${asset.amount}
              <button onClick={() => deleteAsset(asset.id)}>Delete</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default App;
